import * as constants from './constants';

const INITIAL_STATE = {
  isMobileScreen: false,
  isLargeScreen: false,
  screenSize: {
    width: 0,
    height: 0,
  },
  isLogin: false,
  isPageLoaded: false,
  login: {
    state: null,
    phoneNumber: null,
    otpCode: null,
    nextValidTime: null,
    // ... another data from API that needed will be passed here
  },
  loginDac: {
    state: null,
    // ... another data from API that neede
  },
  isStatus: true,
  visibleGlobalError: false,
  popUpAdds: {
    isShown: false,
    urlRedirect: '',
  },
};

const exportedObject = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case constants.SET_SCREEN_SIZE:
      return { ...state, screenSize: action.payload };
    case constants.SET_IS_MOBILE_SCREEN:
      return { ...state, isMobileScreen: action.payload };
    case constants.SET_IS_LARGE_SCREEN:
      return { ...state, isLargeScreen: action.payload };
    case constants.SET_IS_LOGIN:
      return { ...state, isLogin: action.payload };
    case constants.SET_PAGE_LOGIN_DATA:
      return { ...state, login: { ...state?.login, ...action?.payload } };
    case constants.SET_PAGE_DAC_LOGIN_DATA:
      return { ...state, loginDac: { ...state?.loginDac, ...action?.payload } };
    case constants.SET_IS_STATUS:
      return { ...state, isStatus: action.payload };
    case constants.SET_VISIBLE_GLOBAL_ERROR_MODAL:
      return {
        ...state,
        visibleGlobalError: action.payload,
      };
    case constants.SET_POPUP_ADDS:
      return { ...state, popUpAdds: { ...state.popUpAdds, ...action.payload } };
    default:
      return state;
  }
};

export default exportedObject;
